import React, { createContext, useCallback, useContext, useState } from "react";
import { getDataWithToken } from "../services/GetDataService";
import { AuthContext } from "./AuthContext";

export const AppDataContext = createContext();

export default function AppDataContextProvider({ children }) {
  const { logout, ifixit_admin_panel } = useContext(AuthContext);
  const [customerSuggestionReadCount, setCustomerSuggestionReadCount] =
    useState(0);

  const getCustomerSuggestionReadCount = useCallback(async () => {
    const hasPermission = ifixit_admin_panel?.user?.permission?.includes(
      "customer_suggestion_complaint_list",
    );

    if (!hasPermission) {
      return null;
    }

    const response = await getDataWithToken(
      "/api/v1/customerSuggestionComplaint/read-count",
    );

    if (response?.status === 401) {
      logout();
      return null;
    }

    if (response?.status >= 200 && response?.status < 300) {
      const count = response?.data?.totalData ?? 0;
      const parsedCount = Number(count) || 0;

      setCustomerSuggestionReadCount(parsedCount);
      return parsedCount;
    }

    return null;
  }, [logout, ifixit_admin_panel?.user?.permission]);

  const value = {
    customerSuggestionReadCount,
    setCustomerSuggestionReadCount,
    getCustomerSuggestionReadCount,
  };

  return (
    <AppDataContext.Provider value={value}>{children}</AppDataContext.Provider>
  );
}

export const useAppData = () => useContext(AppDataContext);
